import React from 'react';
import PropTypes from 'prop-types';

export const Draft = ({ width, height, ...props }) => (
  <svg
    data-icon='draft'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 14v-2h7v2H4Zm0-4V8h11v2H4Zm0-4V4h11v2H4Zm9 14v-3.075l5.525-5.5c.15-.15.317-.258.5-.325a1.6 1.6 0 0 1 .55-.1 1.504 1.504 0 0 1 1.075.45l.925.925c.133.15.238.317.313.5.074.183.112.367.112.55 0 .183-.033.37-.1.563a1.342 1.342 0 0 1-.325.512l-5.5 5.5H13Zm1.5-1.5h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025v.95Zm3.525-3.525-.475-.45.925.925-.45-.475Z'
    />
  </svg>
);

Draft.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Draft.defaultProps = {
  width: 24,
  height: 24,
};
